var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buzz-script-wrap"},[_c('div',{ref:"buzzStage",staticClass:"buzzplayer-stage",attrs:{"data-debug":"true","data-width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }